module.exports = __webpack_public_path__ + "static/img/home30.2d9690e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home30.png
// module id = Rdh/
// module chunks = 0